import React, { useCallback } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getRequestTutoringModalVisible } from 'logic/store/modal/modal.selectors';
import { modalSlice } from 'logic/store/modal/modal.slice';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { RequestTutoringForm } from './request-tutoring.form';
import { offerSlice } from 'logic/store/offer/offer.slice';

export const RequestTutoringModal = () => {
  const dispatch = useDispatch();
  const { maxTablet } = useBreakpoints();
  const visible = useSelector(getRequestTutoringModalVisible);
  const handleClose = useCallback(() => {
    dispatch(modalSlice.actions.closeRequestTutoringModal());
    dispatch(offerSlice.actions.clearOfferRequestInitValues());
  }, [dispatch]);

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      maskClosable
      footer={null}
      centered
      width={maxTablet ? '95%' : 829}
      style={{
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      <RequestTutoringForm />
    </Modal>
  );
};
